var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.619873,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "#00B885"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.619873,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#F0F1F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1292_12870)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.18525 6.5064L7.32472 6.412C8.10305 5.91267 9.13325 6.08814 9.73152 6.82154L10.5504 7.8292C11.0587 8.45454 11.1307 9.33634 10.7213 10.0247L10.0509 11.1629C9.94298 11.3427 10.2623 11.9142 11.0587 12.7193C11.8639 13.5157 12.4354 13.8351 12.6198 13.7317L13.7535 13.0567C14.4463 12.6519 15.3236 12.7193 15.9534 13.2322L16.9611 14.0511C17.6944 14.6494 17.8699 15.6797 17.366 16.4534L17.276 16.5975C16.5923 17.6591 15.3191 18.2934 14.037 18.0641C12.3768 17.7625 10.6583 16.71 8.85885 14.9195C7.07278 13.1244 6.01558 11.4014 5.71865 9.74581C5.48925 8.46361 6.12352 7.19034 7.18525 6.5064Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3472 6.13407C15.1659 6.10127 14.9926 6.2218 14.96 6.40307C14.9272 6.58414 15.0477 6.75747 15.229 6.79027C16.5116 7.01434 17.5656 8.22687 17.6551 9.53081C17.6623 9.63181 17.6643 9.73301 17.6603 9.83414C17.6529 10.0181 17.7962 10.1731 17.9803 10.1804C18.1642 10.1877 18.3193 10.0445 18.3266 9.86054C18.3315 9.73354 18.3291 9.60707 18.3198 9.48227C18.1959 7.86607 16.9571 6.43161 15.3472 6.13407Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8758 7.58727C14.6946 7.55467 14.5212 7.675 14.4887 7.85627C14.4561 8.03754 14.5765 8.21087 14.7578 8.24347C15.484 8.36687 16.0972 9.07047 16.1456 9.81287L16.1486 9.98567C16.1414 10.1696 16.2848 10.3245 16.4689 10.3316C16.6528 10.3387 16.8077 10.1954 16.8149 10.0115C16.8179 9.92867 16.8164 9.84607 16.8104 9.76441C16.7275 8.70967 15.9295 7.78414 14.8758 7.58727Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1292_12870"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4.11987)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.2703847482f75a8eca268122f8a69f63.svg";
export { ForwardRef as ReactComponent };